"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _excluded = ["title"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Wish = /*#__PURE__*/function (_React$PureComponent) {
  function Wish() {
    (0, _classCallCheck2["default"])(this, Wish);
    return _callSuper(this, Wish, arguments);
  }
  (0, _inherits2["default"])(Wish, _React$PureComponent);
  return (0, _createClass2["default"])(Wish, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        title = _this$props.title,
        props = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      return /*#__PURE__*/_react["default"].createElement(StyledWish, (0, _extends2["default"])({}, props, {
        title: title
      }), title);
    }
  }]);
}(_react["default"].PureComponent);
Wish.propTypes = {
  className: _propTypes["default"].string,
  title: _propTypes["default"].string.isRequired
};
Wish.defaultProps = {
  className: ''
};
var StyledWish = _styledComponents["default"].div.withConfig({
  displayName: "Wish__StyledWish",
  componentId: "sc-1h2r6lc-0"
})(["color:#17181a;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;::before{content:'#';}"]);
var _default = exports["default"] = Wish;